module.exports = __webpack_public_path__ + "static/media/signout.125e7ffa.svg";